import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialQuillDocumentState: Dtos.QuillDocument & IRegistrationFormState = {
    id: null,
    type: null,
    page: null,
    title: null,
    editorState: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    quillDocumentImages: [],
    saveAndReturn: false
}

export interface IQuillDocumentReduxFormState {
    id: IFieldState<number>,
    type: IFieldState<Dtos.QuillDocumentType>,
    page: IFieldState<Dtos.Page>,
    title: IFieldState<string>,
    editorState: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    quillDocumentImages: IFieldState<Dtos.QuillDocumentImage[]>,
}
